export default "__VITE_ASSET__CgLjK5fY__"